<template>
  <div class="shop-items">
    <div v-if="!game" class="loading">请选择游戏</div>
    <template v-else>
      <div class="header">
        <h2>商城管理</h2>
        <el-button type="primary" size="small" @click="showAddDialog">添加商品</el-button>
      </div>

      <!-- 商品列表 -->
      <el-table :data="items" border style="width: 100%">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.url" :src="scope.row.url" style="width: 60px; height: 60px; object-fit: contain;" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="type" label="类型" width="100" />
        <el-table-column label="详情" width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.type === '属性' || scope.row.type === '好感度'">
              <span v-if="scope.row.variable_id">{{ variableLabel(scope.row.variable_id) }} {{ signedValue(scope.row.value) }}</span>
              <span v-else>{{ getRoleName(scope.row.role_id) }} {{ scope.row.attribute_name }} {{ signedValue(scope.row.value) }} <el-tag size="mini" type="warning">待迁移</el-tag></span>
            </template>
            <template v-else>
              {{ scope.row.value || '-' }}
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="价格" width="100" />
        <el-table-column label="限购" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.purchase_limit === -1 || scope.row.purchase_limit === undefined || scope.row.purchase_limit === null">不限购</span>
            <span v-else>限购{{ scope.row.purchase_limit }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="editItem(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="removeItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加/编辑弹窗 -->
      <el-dialog :title="editingItem && editingItem.id ? '编辑商品' : '添加商品'" :visible.sync="dialogVisible" width="500px" append-to-body>
        <el-form v-if="editingItem" :model="editingItem" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="editingItem.name" placeholder="商品名称" />
          </el-form-item>
          <el-form-item label="图片">
            <div class="image-picker">
              <img
                v-if="editingItem.url"
                :src="editingItem.url"
                class="image-picker-preview"
                title="更换图片"
                @click="openPicker"
              />
              <el-button v-else size="small" type="primary" @click="openPicker">选择图片</el-button>
              <!-- 只有本次选过的素材才显示文件名：shop_items 存的是 url、没有 asset_id，
                   重开弹窗无从反查素材名（url 里是 OSS 随机文件名，解析出来没意义） -->
              <div
                v-if="pickedNames[editingItem.url]"
                class="image-picker-name"
                :title="pickedNames[editingItem.url]"
              >
                {{ pickedNames[editingItem.url] }}
              </div>
            </div>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="editingItem.type" placeholder="选择类型" style="width: 100%;" @change="onTypeChange">
              <el-option label="道具" value="道具" />
              <el-option label="属性" value="属性" />
            </el-select>
          </el-form-item>
          <template v-if="editingItem.type === '属性'">
            <el-form-item label="种类">
              <el-select v-model="editingCategoryId" placeholder="选择种类（仅 app 可见）" style="width: 100%;" class="shop-var-category" @change="onCategoryChange">
                <el-option v-for="c in visibleCategories" :key="c.id" :label="categoryLabelOf(c)" :value="c.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="变量">
              <el-select v-model="editingItem.variable_id" placeholder="选择数值型变量" style="width: 100%;" class="shop-var-variable">
                <el-option v-for="v in categoryVariables" :key="v.id" :label="v.display_name ? `${v.name}（${v.display_name}）` : v.name" :value="v.id" />
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="数值">
            <!-- 允许负数（2026-09-17）：购买时按增量叠加到变量，负数即扣减；后端无正数校验、列是有符号 INT -->
            <el-input-number v-model="editingItem.value" style="width: 100%;" />
          </el-form-item>
          <el-form-item label="价格">
            <el-input-number v-model="editingItem.price" :min="0" style="width: 100%;" />
          </el-form-item>
          <el-form-item label="限购设置">
            <el-checkbox v-model="hasLimit">有限制</el-checkbox>
            <el-input-number
              v-if="hasLimit"
              v-model="editingItem.purchase_limit"
              :min="1"
              :max="9999"
              style="margin-left: 10px;"
            />
            <span v-if="!hasLimit" style="margin-left: 10px; color: #999;">不限购</span>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveItem">保存</el-button>
        </span>
      </el-dialog>

      <!-- 商品图是道具图标，只开「通用物品」页签。game-id 有值才会出现「本书素材」页签 -->
      <AssetPickerDialog
        :visible.sync="pickerVisible"
        :kinds="['item']"
        :multiple="false"
        :game-id="game ? game.id : 0"
        @picked="onAssetPicked"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Game } from '@/api/game'
import { Role, getRoles } from '@/api/role'
import { ShopItem, getShopItems, createShopItem, updateShopItem, deleteShopItem } from '@/api/shop'
import { VariableView, VariableCategoryView, listVariables } from '@/api/variable'
import { categoryLeaves, categoryLabel } from '@/utils/variableCategoryHierarchy'
import { signedNumber } from '@/utils/signedNumber'
import type { Asset } from '@/api/asset'
import AssetPickerDialog from '@/components/asset/AssetPickerDialog.vue'

@Component({ components: { AssetPickerDialog } })
export default class ShopItems extends Vue {
  @Prop({ required: true }) readonly game!: Game

  items: ShopItem[] = []
  roles: Role[] = []
  variables: VariableView[] = []
  categories: VariableCategoryView[] = []
  editingCategoryId: number | null = null
  dialogVisible = false
  editingItem: ShopItem | null = null
  hasLimit = false
  pickerVisible = false
  /** url -> 素材名，只记本次会话里选过的，供弹窗显示文件名（见模板里的说明） */
  pickedNames: Record<string, string> = {}

  /** 种类下拉只列 app 可见根下的「叶子」——变量只能挂叶子（352c674 二级种类），带子级的根
      本身列出来选中后变量下拉必空。子级的 app_visible 由后端抄自根，所以按根的可见性筛即可。
      与 VariableManagerDialog 的 visibleLeaves 同一套工具函数 */
  get visibleCategories(): VariableCategoryView[] {
    return categoryLeaves(this.categories, true)
  }

  /** 子级带父名（「主角 / 成长」），两个根下同名子级才分得清；根自己就是根名 */
  categoryLabelOf(c: VariableCategoryView): string {
    return categoryLabel(this.categories, c)
  }

  get categoryVariables(): VariableView[] {
    return this.variables.filter(v => v.type === 'number' && v.category_id === this.editingCategoryId)
  }

  @Watch('hasLimit')
  onHasLimitChange(val: boolean) {
    if (!val && this.editingItem) {
      this.editingItem.purchase_limit = -1
    } else if (val && this.editingItem && (!this.editingItem.purchase_limit || this.editingItem.purchase_limit <= 0)) {
      this.editingItem.purchase_limit = 1
    }
  }

  @Watch('game', { immediate: true })
  onGameChange(newGame: Game) {
    if (newGame && newGame.id) {
      this.loadItems()
      this.loadRoles()
      this.loadVariables()
    }
  }

  async loadItems() {
    try {
      this.items = await getShopItems(this.game.id)
    } catch (error) {
      this.$message.error('加载商品失败')
      this.items = []
    }
  }

  async loadRoles() {
    try {
      this.roles = await getRoles(this.game.id)
    } catch (error) {
      this.roles = []
    }
  }

  async loadVariables() {
    try {
      const resp = await listVariables(this.game.id)
      const d = resp.data.data || {}
      this.variables = d.variables || []
      this.categories = d.categories || []
    } catch (error) {
      this.variables = []
      this.categories = []
    }
  }

  onCategoryChange() {
    if (this.editingItem) {
      this.editingItem.variable_id = null
    }
  }

  onTypeChange() {
    if (this.editingItem && this.editingItem.type !== '属性') {
      this.editingItem.variable_id = null
      this.editingCategoryId = null
    }
  }

  /** 列表里的数值带符号显示：数值可为负后硬拼「+」会出现「+-5」 */
  signedValue(n: number): string {
    return signedNumber(n)
  }

  variableLabel(id: number): string {
    const found = this.variables.find(v => v.id === id)
    return found ? found.name : `变量#${id}`
  }

  getRoleName(roleId: number): string {
    const role = this.roles.find(r => r.id === roleId)
    return role ? role.name : '未知角色'
  }

  showAddDialog() {
    this.editingItem = {
      name: '',
      url: '',
      type: '道具',
      role_id: undefined,
      // 不预置 attribute_name：新建属性商品不填旧键，留空让后端从迁移映射回填，
      // 这里固定发 '' 会覆盖掉后端的回填。
      variable_id: null,
      value: 0,
      price: 0,
      purchase_limit: -1,
      game_id: this.game.id
    }
    this.editingCategoryId = null
    this.hasLimit = false
    this.dialogVisible = true
  }

  editItem(item: ShopItem) {
    this.editingItem = { ...item }
    if (item.type === '好感度') {
      this.editingItem.type = '属性'
      // 好感度商品迁移前 attribute_name 是空串；老路径（开关关时）按 attribute_name
      // 找属性，留空会导致后端报「未配置属性名」而买不了。好感度类型改前的写法
      // 固定是 item_attributes[role]['好感度']，这里原样补回同一个键，role_id 已经
      // 随 { ...item } 带过来了。
      this.editingItem.attribute_name = '好感度'
    }
    const variable = this.variables.find(v => v.id === item.variable_id)
    this.editingCategoryId = variable ? variable.category_id : null
    this.hasLimit = (item.purchase_limit !== undefined && item.purchase_limit !== null && item.purchase_limit > 0)
    if (!this.hasLimit) {
      this.editingItem.purchase_limit = -1
    }
    this.dialogVisible = true
  }

  async saveItem() {
    if (!this.editingItem) return
    if (!this.editingItem.name) {
      this.$message.warning('请输入商品名称')
      return
    }
    if (this.editingItem.type === '属性' && !this.editingItem.variable_id) {
      this.$message.warning('属性商品必须选择变量')
      return
    }

    const payload: ShopItem = { ...this.editingItem }
    delete payload.variable_name

    try {
      if (this.editingItem.id) {
        await updateShopItem(this.editingItem.id, payload)
        this.$message.success('更新成功')
      } else {
        await createShopItem(payload)
        this.$message.success('创建成功')
      }
      this.dialogVisible = false
      this.loadItems()
    } catch (error) {
      this.$message.error('保存失败')
    }
  }

  async removeItem(item: ShopItem) {
    if (!item.id) return

    try {
      await this.$confirm('确定删除该商品？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })

      await deleteShopItem(item.id)
      this.$message.success('删除成功')
      this.loadItems()
    } catch (error) {
      if (error !== 'cancel') {
        this.$message.error('删除失败')
      }
    }
  }

  openPicker() {
    this.pickerVisible = true
  }

  /** 选中即写草稿，仍需点「保存」才落库，与弹窗里其余字段一致。
      选择器交回的 Asset 就是权威数据（可能是作者刚上传的新素材），直接用 */
  onAssetPicked(a: Asset) {
    if (!this.editingItem) return
    this.$set(this.editingItem, 'url', a.url)
    this.$set(this.pickedNames, a.url, a.name)
  }
}
</script>

<style scoped>
.shop-items {
  padding: 20px;
}

.loading {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
}

/* 预览尺寸与改版前的内联 style 保持一致（max 200x200），不加边框以免视觉上变大；
   可点击靠 title 提示 + hover 半透明 */
.image-picker-preview {
  display: block;
  max-width: 200px;
  max-height: 200px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.image-picker-preview:hover {
  opacity: 0.75;
}

/* el-form-item 的行高是 40px，文件名这行要自己压回来 */
.image-picker-name {
  max-width: 260px;
  margin-top: 4px;
  color: #606266;
  font-size: 12px;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
